module.exports = __webpack_public_path__ + "static/media/proj2_img1.005a8996.jpg";